import { getModuleUrl, i18n } from "@dehub/theme";
import { store, persistor } from "../store";
import { message } from "./message";
import { authChange } from "../store/Auth";
import HttpHandler from "./http-handler";
import { HttpRequest as BaseHttpRequest } from "./http-request";

let sessionExpiredHandled = false;

export class HttpRequest extends BaseHttpRequest {
  store = store;
  errorHandler = (statusCode: number, error: HttpHandler): void => {
    if (statusCode === 401 && !sessionExpiredHandled) {
      sessionExpiredHandled = true;
      store.dispatch(authChange());
      message.error(i18n.t("common:session.expired", { defaultValue: "Таны нэвтэрсэн хугацаа дууссан байна. Дахин нэвтэрнэ үү." }));

      const h = window.location.hostname.split(".");
      const loginUrl = `${h.length >= 3 && h[0] === "b2b" ? window.location.origin : getModuleUrl("")}/login?logout=1`;

      persistor.purge().finally(() => {
        setTimeout(() => {
          window.location.href = loginUrl;
        }, 1500);
      });
    }

    throw error;
  };
}
